import { render } from "./HeroiconsSolidLightningBolt.vue?vue&type=template&id=7535e928"
const script = {}

import exportComponent from "/home/roland/vscode/yachtbroker/portal/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidLightningBolt.vue"]])

export default __exports__